export default __webpack_public_path__ + "static/media/img--interiors-5.8267aa2e.jpg";